<template>
  <div class="edit-study-set">
    <organization-breadcrumb
      :items="[$t('study_sets.curriculum'), $t('study_sets.study_set')]"
    />
    <div id="edit-study-set-page">
      <el-row type="flex" justify="center">
        <el-col :xs="24" :md="14">
          <div>
            <el-button @click="handleCancel" type="text" class="back-text">
              <i class="el-icon-back"></i>
              {{ $t("study_sets.back") }}
            </el-button>
          </div>
          <div>
            <div class="study-set-edit-main">
              <study-set-duplicate-detail
                ref="studysetdetail"
                :currentStep="createStudySetSteps.active"
                :componentStep="1"
                :isAdmin="true"
                :editMode="true"
                :organizationType="currentOrganizationType"
              />
            </div>
            <div>
              <api-errors :errors="errors" />
              <study-set-duplicate-footer
                v-if="createStudySetSteps.active == 1"
                :primaryPreviousActive="false"
                :primaryAction="updateClass"
                :primaryCancelAction="handleCancel"
                primaryText="Next"
                :previousText="$t('common.cancel')"
              />
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <leave-create-study-set-modal
      :dialogVisible="modals.showLeaveCreateStudySetModal"
      v-on:closed="modals.showLeaveCreateStudySetModal = false"
      v-on:leave="handleConfirmCancel"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { successMessage, warningMessage } from "@/utils/messages";
import StudySetDuplicateDetail from "@/components/studysets/duplicate-studysets/StudySetDuplicateDetail";
import StudySetDuplicateFooter from "@/components/studysets/duplicate-studysets/StudySetDuplicateFooter";
import OrganizationBreadcrumb from "@/components/common/OrganizationBreadcrumb";
import ApiErrors from "@/components/common/ApiErrors";
import { DefaultShareableOptions } from "@/constants/studySets";
import LeaveCreateStudySetModal from "@/components/modals/studysets/LeaveCreateStudySetModal";

export default {
  components: {
    LeaveCreateStudySetModal,
    ApiErrors,
    StudySetDuplicateDetail,
    StudySetDuplicateFooter,
    OrganizationBreadcrumb,
  },
  props: {
    currentStep: {
      type: Number,
      default: 1,
    },
    componentStep: {
      type: Number,
      default: 1,
    },
    tertiaryFunction: {
      type: Function,
      default: null,
    },
    organizationType: {
      type: String,
      default: "",
    },
    studySetId: {},
  },
  data() {
    return {
      modals: {
        showLeaveCreateStudySetModal: false,
      },
      errors: {},
      primaryLoading: false,
      shareableOptions: DefaultShareableOptions,
      createStudySetSteps: {
        active: 1,
        steps: [
          {
            title: this.$t("studysets.create_studyset_flow.details"),
          },
          {
            title: this.$t("study_sets.review_confirm"),
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      getCurrentStudySet: "studysets/getCurrentStudySet",
      studySet: "studysets/getBuildingStudySet",
      currentOrganizationId: "organization/currentOrganizationId",
      categories: "studysets/getStudySetCategories",
      currentOrganizationType: "organization/currentOrganizationType",
    }),
    categoriesOptions() {
      return this.categories.map((x) => {
        return { label: x, value: x };
      });
    },
    studySetDetails() {
      return this.studySet;
    },
    modalTitle() {
      return this.currentStep === -1
        ? this.$t(
            this.$i18nLabelsHelper(this.organizationType, "group_details")
          )
        : this.$t(
            this.$i18nLabelsHelper(this.organizationType, "step_group_details")
          );
    },
    isDisabledComponent() {
      return this.currentStep > this.componentStep && this.editMode == false;
    },
  },
  async mounted() {
    try {
      await this.$store.dispatch("studysets/resetBuildingStudySet");
      await this.$store.dispatch("studysets/getStudySet", {
        studySetId: this.studySetId,
      });
      const currentStudySet = this.getCurrentStudySet;
      // update building class

      var buildingStudySetData = {
        name: this.$t("common.copy_of") + currentStudySet.name,
        category: currentStudySet.category,
        shareable: currentStudySet.shareable,
        phrases: currentStudySet.phrases.map((x) => {
          return { text: x };
        }),
        id: currentStudySet.id,
      };
      await this.updateBuildingStudySet(buildingStudySetData);
    } catch (error) {
      return warningMessage(this.$t("common.generic_error_message"))(this);
    }
  },
  methods: {
    ...mapActions({
      updateBuildingStudySet: "studysets/updateBuildingStudySet",
      updateStudySet: "studysets/updateStudySet",
      createStudySetAction: "studysets/createStudySet",
    }),
    hasHistory() {
      return window.history.length > 2;
    },
    handleNextStep(activeStep, options = {}) {
      // const activeStep = this.createClassSteps.active;
      if (options.mode === "file-import") {
        this.uploadId = options.uploadId;
        this.inviteMode = options.mode;
      }
    },
    handleCancel() {
      this.modals.showLeaveCreateStudySetModal = true;
    },
    handleConfirmCancel() {
      // leave
      // this.createClassSteps.active = 1
      this.modals.showLeaveCreateStudySetModal = false;
      if (this.hasHistory()) {
        this.$router.go(-1);
      } else {
        this.$store.dispatch("studysets/resetBuildingStudySet");
        return this.$router.push({
          name: "studysets",
          params: {
            studySetId: this.studySetId,
          },
        });
      }
    },
    async updateClass() {
      try {
        this.primaryLoading = true;
        this.$refs.studysetdetail.handleContinueClick();

        await this.createStudySetAction(this.studySet);

        this.primaryLoading = false;

        successMessage(
          this.$t("study_sets.success_class_duplicated"),
          "elsa-message success",
          {
            showClose: false,
          }
        )(this);

        if (this.hasHistory()) {
          this.$router.go(-1);
        } else {
          this.$store.dispatch("studysets/resetBuildingStudySet");
          return this.$router.push({
            name: "studysets",
            params: {
              studySetId: this.studySetId,
            },
          });
        }
      } catch (error) {
        this.errors = error;
        this.primaryLoading = false;
      }
    },
  },
  destroyed() {
    this.$store.dispatch("studysets/resetBuildingStudySet");
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/_colors.scss";

.back-text {
  color: $hyperlink;
  font-weight: 600;
}

.edit-study-set {
  width: 100%;
}
#edit-study-set-page {
  margin: 24px;
  @media only screen and (max-width: 768px) {
    margin: 0 30px;
  }
  h1 {
    border: 0;
  }
  .study-set-edit-steps {
    margin-top: 25px;
  }
  .study-set-edit-main {
    background-color: white;
    padding: 0px 0px 10px 0px;
  }
  ::v-deep .base-create-header {
    padding-bottom: 34px;
  }
  ::v-deep .circle-step {
    border: 1px solid #e6e6e6;
    box-sizing: border-box;
    border-radius: 23px;
    width: 40px;
    height: 40px;
    display: inline-flex;
    justify-content: center;
    padding-top: 8px;
    margin-right: 16px;
  }
}

.success-info {
  .success {
    font-weight: bold;
    font-size: 22px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: #46c779;
    line-height: 30px;
  }
  p {
    margin-top: 20px;
    font-weight: 300;
    font-size: 18px;
    color: #546873;
    margin: 0;
  }
}
::v-deep .create-study-set-com-disable {
  opacity: 0.5;
}
.line-separate {
  border: 1px solid#E6E6E6;
  margin-bottom: 32px;
}
</style>
